import PropTypes from "prop-types";
import Wrapper from "../../assets/wrappers/Job";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { customFetch } from "../../utils/custom-fetch";
import { useState } from "react";

const Message = ({ _id, messageType, messageDetails, onDelete, buildingId }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await customFetch.delete(`/messages/${_id}`);
      toast.success("ההודעה נמחקה בהצלחה");
      onDelete(_id);
    } catch (error) {
      toast.error(error.response?.data?.msg || "שגיאה במחיקת ההודעה");
    } finally {
      setIsDeleting(false);
    }
  };

  const renderDetails = () => {
    if (messageType === "יום הולדת") {
      return (
        <div>
          <p>חוגג: {messageDetails.celebratorName}</p>
          <p>ברכה: {messageDetails.greeting}</p>
          <p>תאריך יום הולדת: {messageDetails.birthdayDate}</p>
        </div>
      );
    } else if (messageType === "כללית") {
      return (
        <div>
          <p>{messageDetails.text}</p>
          {messageDetails.expirationDate && (
            <p>תוקף: {messageDetails.expirationDate}</p>
          )}
        </div>
      );
    }
  };

  return (
    <Wrapper style={{ margin: "10px" }}>
      <header>
        <h4>סוג הודעה: {messageType}</h4>
      </header>
      <div className="content">{renderDetails()}</div>
      <div className="btn-container" style={btnContainerStyle}>
        {/* כפתור עריכה */}
        <Link
          to={`/dashboard/add-message/${buildingId}/${_id}`}
          className="btn btn-edit"
          style={buttonStyle}
        >
          <FaEdit size={20} />
        </Link>

        <button
          onClick={handleDelete}
          className="btn btn-delete"
          style={buttonStyle}
          disabled={isDeleting}
        >
          {isDeleting ? "..." : <FaTrash size={20} />}
        </button>
      </div>
    </Wrapper>
  );
};

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  backgroundColor: "#f0f0f0",
  borderRadius: "5px",
  color: "#333",
  textDecoration: "none",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
};

const btnContainerStyle = {
  display: "flex",
  justifyContent: "flex-start",
  gap: "10px",
  margin: "10px",
};

Message.propTypes = {
  _id: PropTypes.string.isRequired,
  messageType: PropTypes.string.isRequired,
  buildingId: PropTypes.string.isRequired, 
  messageDetails: PropTypes.shape({
    text: PropTypes.string,
    celebratorName: PropTypes.string,
    greeting: PropTypes.string,
    birthdayDate: PropTypes.string,
    expirationDate: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default Message;
